import React from 'react';

export default function I18nStrong(chunks: React.ReactNode) {
  return <strong>{chunks}</strong>;
}
